/* eslint-disable no-param-reassign */
import { get } from 'lodash'
import qs from 'qs'

function withUrlParams(Component) {
  return function WithColorComponent(props) {
    const urlQueryParams = qs.parse(get(props, 'history.location.search'))

    const urlRouteParams = get(props, 'match.params')

    return (
      <Component
        {...props}
        urlParams={Object.keys(urlQueryParams).reduce(
          (a, k) => {
            if (k.startsWith('?')) {
              a[k.substring(1)] = urlQueryParams[k]
            } else {
              a[k] = urlQueryParams[k]
            }
            return a
          },
          { routeParams: urlRouteParams }
        )}
      />
    )
  }
}

export default withUrlParams
